// extracted by mini-css-extract-plugin
export var csatScore = "_ha-5";
export var header = "_ha-1";
export var panelWrapper = "_ha-2";
export var postPreview = "_ha-3";
export var rightContent = "_ha-0";
export var wrappingText = "_ha-4";